import React from "react";
import {SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class RedRecordCircleIcon extends React.Component {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 8 8">
                <circle cx="4" cy="4" r="4" fill="#F12727"/>
            </SvgIcon>
        );
    }
}
